export default String.raw`
<defs>
    <rect id="path-1" x="0" y="0" width="327.07" height="75"></rect>
</defs>
<g id="12.-Lista-towarów_Prezentacja-atrybutów_Mobile" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
    <rect class="bgColor" x="0" y="0" width="329" height="124"></rect>
    <g id="Group-11" transform="translate(1.000000, 1.000000)">
        <g id="Group-10-Copy">
            <rect id="Rectangle" class="lightBorderColor--stroke" x="0.0695307116" y="0" width="327" height="122"></rect>
            <text id="Obuwie-męskie" font-family="Roboto-Bold, Roboto" font-size="16" font-weight="bold" class="primaryColorFont">
                <tspan x="12.0695307" y="30">Telefony i zegarki</tspan>
            </text>
            <line x1="-2.72187465e-13" y1="47" x2="326.998476" y2="47" id="Line" class="lightBorderColor--stroke" stroke-linecap="square"></line>
            <g transform="translate(295, -10)">
                <use class="primaryColorFont primaryColorFont--stroke" xlink:href="#angle-up" width="48" height="48" transform="scale(10)"></use>
            </g>
        </g>
        <g id="pexels-cottonbro-6153367" transform="translate(0.000000, 47.000000)">
            <mask id="mask-2" fill="white">
                <use xlink:href="#path-1"></use>
            </mask>
            <use id="Mask" fill="#D8D8D8" xlink:href="#path-1"></use>
            <image id="pexels-ingo-joseph-609771" mask="url(#mask-2)" x="0" y="-124" width="327.07" height="330" href="./img/previewElements/categoryDescription_1.png"></image>
        </g>
    </g>
</g>
`;